import _ from 'lodash';

export const DEFAULT_PAGE_SIZE = 50;

export const pageNames = {
  HOME: 'home',
  SKUS_MANAGEMENT: 'skusManagement',
  SKUS_CARRIERS: 'skusCarriers',
  SKUS_SET: 'skusSet',
  ORDER_PAYMENT_WAIT: 'orderPaymentWait',
  ORDER_NEW: 'orderNew',
  ORDER_SHIPMENT: 'orderShipment',
  ORDER_SHIPPING: 'orderShipping',
  ORDER_CLAIM: 'orderClaim',
  MARKET_PRODUCTS: 'marketProducts',
  CS_LIST: 'csList',
  STATISTICS_REVENUE: 'statisticsRevenue',
  SETTINGS_USERS: 'settingsUsers',
  SETTINGS_MARKET: 'settingsMarket',
  SETTINGS_ORDER_LOG: 'settingsOrderLog',
  SETTINGS_DEPOT: 'settingsDepot',
  SETTINGS_CARRIER: 'settingsCarrier',
  SETTINGS_WORK_LOG: 'settingsWorkLog',
  SETTINGS_CONFIG: 'settingsConfig',
};

export const pageTypes = {
  HOME: '/home',
  SKUS_MANAGEMENT: '/skus/management',
  SKUS_CARRIERS: '/skus/carriers',
  SKUS_SET: '/skus/set',
  ORDER_PAYMENT_WAIT: '/order/paymentWait',
  ORDER_NEW: '/order/new',
  ORDER_SHIPMENT: '/order/shipment',
  ORDER_SHIPPING: '/order/shipping',
  ORDER_CLAIM: '/order/claim',
  MARKET_PRODUCTS: '/market/products',
  CS_LIST: '/cs/list',
  STATISTICS_REVENUE: '/statistics/revenue',
  SETTINGS_USERS: '/settings/users',
  SETTINGS_MARKET: '/settings/market',
  SETTINGS_ORDER_LOG: '/settings/orderLog',
  SETTINGS_DEPOT: '/settings/depot',
  SETTINGS_CARRIER: '/settings/carrier',
  SETTINGS_WORK_LOG: '/settings/workLog',
  SETTINGS_CONFIG: '/settings/config',
};

export const pageTypeValues = _.values(pageTypes);

export const pageLabels = {
  [pageTypes.HOME]: '홈',
  [pageTypes.SKUS_MANAGEMENT]: '옵션 SKU 상품관리',
  [pageTypes.SKUS_CARRIERS]: '옵션 SKU 운송사매칭',
  [pageTypes.SKUS_SET]: '세트상품관리',
  [pageTypes.ORDER_PAYMENT_WAIT]: '결제대기',
  [pageTypes.ORDER_NEW]: '신규주문',
  [pageTypes.ORDER_SHIPMENT]: '출고관리',
  [pageTypes.ORDER_SHIPPING]: '배송관리',
  [pageTypes.ORDER_CLAIM]: '클레임주문관리',
  [pageTypes.MARKET_PRODUCTS]: '상품관리 목록',
  [pageTypes.CS_LIST]: 'CS 목록',
  [pageTypes.STATISTICS_REVENUE]: '주문 매출 통계',
  [pageTypes.SETTINGS_USERS]: '사용자 관리',
  [pageTypes.SETTINGS_MARKET]: '마켓 설정',
  [pageTypes.SETTINGS_ORDER_LOG]: '주문연동 로그관리',
  [pageTypes.SETTINGS_DEPOT]: '배송처 관리',
  [pageTypes.SETTINGS_CARRIER]: '운송사 관리',
  [pageTypes.SETTINGS_WORK_LOG]: '작업 로그 관리',
  [pageTypes.SETTINGS_CONFIG]: '환경설정',
};

export const ORDER_STATUS = {
  PAYMENT_WAIT: 'PWAIT',
  NEW_ORDER: 'BNEWO',
  SHIPMENT_WAIT: 'BRDYS',
  BEFORE_SHIPPING_DELAY: 'BDLAY',
  SHIPPING_COMPLETE: 'BRLDS',
  SHIPPING: 'SPING',
  SHIPPING_DELAY: 'SDLAY',
  DELIVERY_COMPLETE: 'ASCOM',
  PAYMENT_CANCEL_REQUEST: 'PCAPL',
  PAYMENT_CANCEL_COMPLETE: 'PCCOM',
  CANCEL_REQUEST: 'BCAPL',
  CANCEL_COMPLETE: 'BCCOM',
  REFUND_REQUEST: 'ARFAP',
  REFUND_COMPLETE: 'ARFCO',
  REFUND_PARTIAL_CANCEL: 'ARFCP',
  EXCHANGE_REQUEST: 'AEXAP',
  EXCHANGE_WAIT: 'AEXPD',
  EXCHANGE_SHIPPING: 'AEXSI',
  EXCHANGE_COMPLETE: 'AEXCO',
  RETURN_REQUEST: 'ARTAP',
  RETURN_WAIT: 'ARTPD',
  RETURN_SHIPPING: 'ARTSI',
  RETURN_REFUND: 'ARTPP',
  RETURN_COMPLETE: 'ARTCO',
  RETURN_EXCHANGE_REQUEST: 'ARTAP&AEXAP',
};

export const PRODUCT_STATUS = {
  SP: 'SP',
  SS: 'SS',
  SO: 'SO',
  ES: 'ES',
  SE: 'SE',
  EPS: 'EPS',
};

export const TODAY_STATUS = {
  CLAIM: 'CLAIM',
};

export const MALLS_ID = {
  QOO_10: 1,
  RAKUTEN: 2,
  SHOPEE: 3,
};
//
export const MALLS_CODE = {
  QOO_10: 'qooten_jp',
  RAKUTEN: 'rakuten_jp',
  SHOPEE: 'shopee_sg',
  SHOPEE_GLOBAL: 'shopee_global',
  CUSTOM_MALL: 'custom_mall',
};
